import React from 'react';
import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { WithStyles, createStyles, Theme, Breadcrumbs, Link } from '@material-ui/core';
import logo from './scisports-logo.svg';
import useMe from '../Util/useMe';
import HeaderMenu from './HeaderMenu';
import { useSnackbar } from 'notistack';
import routes from '../../routes';
import { Route, Switch } from 'react-router-dom';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      zIndex: theme.zIndex.drawer + 1,
      height: 80,
      backgroundColor: 'black',
    },
  });

interface Props extends WithStyles<typeof styles> {}

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Link1 = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
));

const Header: React.FunctionComponent<Props> = (props) => {
  const { data, error } = useMe();
  const { enqueueSnackbar } = useSnackbar();

  if (error) {
    enqueueSnackbar('Failed to load user profile', { variant: 'error', autoHideDuration: 3000 });
  }
  return (
    <AppBar
      position="static"
      classes={{
        root: props.classes.root,
      }}>
      <Toolbar
        classes={{
          root: props.classes.root,
        }}>
        <FlexWrapper>
          <LogoWrapper>
            <img src={logo} alt="" style={{ height: '30px' }} />
          </LogoWrapper>
          <Switch>
            {routes
              .filter((route) => route.breadCrumb)
              .map((route, index) => (
                <Route
                  exact={true}
                  key={index}
                  path={route.path}
                  render={(props) => {
                    return (
                      <Breadcrumbs
                        separator={<NavigateNextIcon style={{ color: 'white' }} fontSize="small" />}
                        aria-label="breadcrumb">
                        <Link
                          style={{ color: 'white' }}
                          component={Link1}
                          color="textSecondary"
                          to="/"
                          underline="none">
                          Home
                        </Link>
                        {route.breadCrumb &&
                          route.breadCrumb.map((bc, index) => {
                            let title: any = bc.t;
                            if (typeof bc.t === 'function') {
                              const Element: any = bc.t;
                              title = <Element match={props.match} />;
                            }
                            let href = props.location.pathname;
                            if (bc.l) {
                              if (typeof bc.l === 'function') {
                                href = bc.l(props.match);
                              } else {
                                href = bc.l;
                              }
                            }
                            return (
                              <Link
                                style={{ color: 'white' }}
                                component={Link1}
                                key={index}
                                color="textSecondary"
                                to={href}
                                underline="none">
                                {title}
                              </Link>
                            );
                          })}
                      </Breadcrumbs>
                    );
                  }}
                />
              ))}
          </Switch>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" color="inherit">
              {data && data.me ? data.me.lastname + ', ' + data.me.firstname : ''}
            </Typography>
            <HeaderMenu />
          </div>
        </FlexWrapper>
      </Toolbar>
    </AppBar>
  );
};

export default withStyles(styles)(Header);
